import { useLoading } from '@pok/weblib/context/loading-context';
import FbFull from '../assets/images/share/x_full.png';
import { getShareOGUrl } from '../interact';
import TwitterIcon from './icons/TwitterIcon';
import FullImageShare from './ui/FullImageShare';

export default function TwitterShareButton({ certificate, validated, onSendEvent, fullIcon, sharePostTitle }) {
    const { showLoading, hideLoading } = useLoading();
    const handleShare = () => {
        showLoading();
        getShareOGUrl(certificate, 'es')
            .then((url) => window.open(`https://twitter.com/intent/tweet?text=${sharePostTitle}&url=${url}`, '_blank'))
            .finally(hideLoading);
        onSendEvent('facebook');
    };

    return (
        <>
            {validated && (
                <span onClick={() => handleShare()} style={{ cursor: 'pointer' }}>
                    {fullIcon && <FullImageShare img={FbFull} />}
                    {!fullIcon && <TwitterIcon />}
                </span>
            )}
            {!validated && <TwitterIcon fill={'#F6F6F6'} icon={'#CCC9D1'} />}
        </>
    );
}
